"use strict";
// @ts-ignore
try {
    self['workbox:strategies:6.5.2'] && _();
}
catch (e) { }
